import styled from 'styled-components'

export const ButtonChildrenContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`

export const ButtonOnlyIconContainer = styled(ButtonChildrenContainer)`
  gap: 0.25rem;
`
